import React from 'react';
import { useAppContext } from '../../contexts/MarketPerformanceContext';
import RisesOrFallsTable from './RisesOrFallsTable';
import LastUpdatedIndicator from './LastUpdatedIndicator';

const RisesAndFallsTable = () => {
    const { state: { marketIndex } } = useAppContext();

    return (
        <div className="rises-falls-lastupdate-container">
            <div className="d-flex d-lg-none justify-content-start justify-content-sm-end w-100 fb-mt-7">
                {(!marketIndex.asAt || !marketIndex.asAt.length) ? <p>Last updated date not available.</p> :
                    <LastUpdatedIndicator />
                }
            </div>
            <div className="w-100">
                {(!marketIndex.risesAndFalls || marketIndex.risesAndFalls.length === 0) ? <p>Data not available.</p> :
                    <div className="row rises-falls-table">
                        <div className="col-12 col-md-6 fb-pt-7 ">
                            <RisesOrFallsTable title="Top rises" data={marketIndex.risesAndFalls.rises} iconCssClasses="arrow-solid-head-green" />
                        </div>
                        <div className="col-12 col-md-6 fb-pt-7">
                            <RisesOrFallsTable title="Top falls" data={marketIndex.risesAndFalls.falls} iconCssClasses="arrow-solid-head-red arrow-down" />
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default RisesAndFallsTable;
